export default __webpack_public_path__ + "2752e2056938cff4c5121df192205b0c.png";